import * as signalR from '@aspnet/signalr';
import { remove } from 'lodash';

import { getAuthToken } from '../../auth';
import Config from '../../config';

const INITIAL_RECONNECT_DELAY_MS = 5000;
const MAX_RECONNECT_DELAY_MS = 120000;

// This is the initial delay, it bumps up for each reconnect attempt
let reconnectDelayMS = INITIAL_RECONNECT_DELAY_MS;
let isFirstConnection = true;

const reconnectionMessageHandlers = [];

const connection = new signalR.HubConnectionBuilder()
  .withUrl(`${Config.API_URL}${Config.WEBSOCKET_PATH}`, {
    accessTokenFactory: getAuthToken,
  })
  .configureLogging(signalR.LogLevel.Information)
  .build();

const attemptConnection = async () => {
  try {
    await connection.start();
    console.devLog.info('Websocket connected with SignalR');

    if (!isFirstConnection) {
      console.devLog.info(
        'Websocket reconnected, calling reconnection handlers',
      );
      reconnectionMessageHandlers.forEach((handler) => handler());
    }

    // If we reconnect successfully, reset the delay to min
    reconnectDelayMS = INITIAL_RECONNECT_DELAY_MS;
    isFirstConnection = false;
  } catch (err) {
    reconnectDelayMS *= 2;
    reconnectDelayMS = Math.min(reconnectDelayMS, MAX_RECONNECT_DELAY_MS);

    console.devLog.info(
      `Failed to connect WS: ${err.toString()}, trying to reconnect in ${
        reconnectDelayMS / 1000
      } seconds`,
    );

    setTimeout(attemptConnection, reconnectDelayMS);
  }
};

// If the connection closes, attempt to reopen it
connection.onclose(async (err) => {
  console.devLog.info(`Websocket closed, attempting to reconnect`, err);
  // No need to await this
  attemptConnection();
});

const addWSMessageListener = (label, handler, reconnectionMessageHandler) => {
  console.devLog.info(`Added ws listener for ${label}`);
  connection.on(label, handler);

  reconnectionMessageHandlers.push(reconnectionMessageHandler);
};

const removeWSMessageListener = (
  label,
  handler,
  reconnectionMessageHandler,
) => {
  console.devLog.info(`Removed ws listener for ${label}`);
  connection.off(label, handler);

  remove(
    reconnectionMessageHandlers,
    (func) => func === reconnectionMessageHandler,
  );
};

if (Config.WEBSOCKET_PATH.length > 0) {
  // Fire up the connection at launch if we've configured a websocket path
  attemptConnection();
}

export { addWSMessageListener, removeWSMessageListener };
